/* Config */
import { Config } from './../config/app.config';
import  map from 'lodash.map'
import without from 'lodash.without';
import find from 'lodash.find';
import sortBy from 'lodash.sortby';
import flatten from 'lodash.flatten';
import uniq from 'lodash.uniq';
import pickBy from 'lodash.pickby';

export function augmentColumnWithNDNodes(col, seenNodes, _overrideStandard, parentNodes) {
  //if(col.length === 0 || col.length > 5) return;

  var newCol = [];
  col.forEach((c,i) => {
    //var nds = nodes[c].nd_edge.filter(n => parentNodes[n.id] && !seenNodes[n.id]).map(n => n.id);
    var nds = nodes[c].nd_edge.filter(n => {
      let domain = window.cc.clusters[nodes[n.id].ccmathcluster_id].ccmathdomain_id;
      let grade = window.cc.domains[domain].grade;
      if (grade && grade === 'HS') {
        return !seenNodes[n.id];
      } else {
        return parentNodes[n.id] && !seenNodes[n.id];
      }
    }).map(n => n.id);
    var first_half = nds.slice(0, nds.length/2);
    var second_half = nds.slice(nds.length/2);
    newCol = newCol.concat(first_half, [c], second_half)
    first_half.forEach(n => seenNodes[n] = 1);
    second_half.forEach(n => seenNodes[n] = 1);
  });

  return newCol;

}

export function layoutSubGraph(parentNodes, _root, degrees, _overrideStandard) {
  var columns = [];
  var nColumns = 1 + degrees * 2;
  for (var i = 0; i < nColumns; i++) columns[i] = [];
  var mid = Math.floor(nColumns / 2);

  var root = _root.replace(/^(.*?)\.[ABC](\..+)?$/, '$1$2');
  let getDomainByStandard = function(_standard) {
    let cluster_id = _standard ? nodes[_standard].ccmathcluster_id: null;
    let cluster = {};
    cluster = map(window.cc.clusters, function(c) {
      if (c.id === cluster_id) return c;
    });
    cluster = without(cluster, undefined);
    let _domain = find(window.cc.domains, (d) => d.id === cluster[0].ccmathdomain_id);
    return _domain;
  }

  let _getDomain = getDomainByStandard(root);

  var seenNodes = {};

  const directional = (ids, accessor) => uniq(flatten(ids.map((n) => accessor(n).map((n) => n.id).filter((n) => {
    let isHS = false;
    if (!parentNodes[n]) {
      let domain = window.cc.clusters[nodes[n].ccmathcluster_id].ccmathdomain_id;
      let grade = window.cc.domains[domain].grade;
      if (grade && grade === 'HS') {
        isHS = true;
      }
    }
    if (isHS) {
      return !seenNodes[n];
    }
    return !seenNodes[n] && parentNodes[n];
  }).slice(/*0,3*/))));

  columns[mid] = [nodes[root].id];

  columns[mid].forEach((v) => { seenNodes[v] = 1; });

  //var nodeSort = (n) => require('./standards-utils').standardCode(n).replace('K.', '0.');
  if (_getDomain && _getDomain.grade && _getDomain.grade === 'HS') {
    // Keep on child standards
    columns[mid - 1] = nodes[root].rev_edge.map((n) => n.id).filter((n) => !seenNodes[n]);
    columns[mid + 1] = nodes[root].edge.map((n) => n.id).filter((n) => !seenNodes[n]);
  } else {
    columns[mid - 1] = directional([root], (n) => nodes[n].rev_edge);
    columns[mid + 1] = directional([root], (n) => nodes[n].edge);
  }

  columns[mid - 1].forEach((v) => { seenNodes[v] = 1; });

  columns[mid + 1].forEach((v) => { seenNodes[v] = 1; });

  if (degrees === 2) {
    
    if (_getDomain && _getDomain.grade && _getDomain.grade === 'HS') {
      // Keep on child standards
      columns[mid - 2] = uniq(flatten(columns[mid - 1].map((n) => nodes[n].rev_edge.map((n) => n.id).filter((n) => !seenNodes[n]).slice(/*0,3*/))));
      columns[mid + 2] = uniq(flatten(columns[mid + 1].map((n) => nodes[n].edge.map((n) => n.id).filter((n) => !seenNodes[n]).slice(/*0,3*/))));
    } else {
      columns[mid - 2] = directional(columns[mid - 1], (n) => nodes[n].rev_edge);
      columns[mid + 2] = directional(columns[mid + 1], (n) => nodes[n].edge);
    }
  }
  columns[mid - 2].forEach((v) => { seenNodes[v] = 1; });

  columns[mid + 2].forEach((v) => { seenNodes[v] = 1; });


  columns = columns.map((c, i) => (i > 0 && i < 4) ? augmentColumnWithNDNodes(c, seenNodes, _overrideStandard, parentNodes) : c);
  // Additional rule (2019 August) - add root--ND->D in column 3, and add root--ND--ND in column 2
  // re-do column 3 (from column 2 which now has ND) by resetting seenNodes
  columns[mid + 1].forEach((v) => { seenNodes[v] = 0; });
  columns[mid + 1] = directional(columns[mid + 0], (n) => nodes[n].edge);

  columns[2] = augmentColumnWithNDNodes(columns[2], seenNodes, _overrideStandard, parentNodes);
  //re-doing column 2 may have introduced repeated nodes, so let's double check on the next column
  columns[3] && (columns[3] = columns[3].filter(item => !columns[2].includes(item)));
  sortGraphColumnsForHS(columns, _getDomain);
  return columns;
}

export function collapseHeight(s) {
  var lines = Math.ceil(s.desc.replace(/(<([^>]+)>)/ig, '').length / 70);
  var hasChild = pickBy(window.cc.standards, (x) => x.ccmathcluster_id === s.ccmathcluster_id && x.ordinal.indexOf(s.ordinal + '.') === 0).length > 0;
  // console.log('hasChild => ', hasChild);
  if (lines < 5) {
    return 128 + 24 * lines + (hasChild ? 100 : 0);
  }
  lines = Math.min(lines, 4);
  return 128 + 24 * lines;
};

export function displayCourseResultsMethodology(value) {
  value = value||0;
  let rs = [];
  for (var key in Config.course_results_methodology) {
    if (!Config.course_results_methodology.hasOwnProperty(key)) continue;

    var obj = Config.course_results_methodology[key];
    if (obj.from && obj.to && value >= obj.from && value <= obj.to) {
      rs.push(obj);
    } else if(obj.from && !obj.to && value >= obj.from) {
      rs.push(obj);
    } else if (obj.to && !obj.from && value <= obj.to) {
      rs.push(obj);
    }
  }
  return rs[0] ? rs[0] : '';
}

function sortGraphColumnsForHS(subgraph, _getDomain) {
  let listClusterByStandard = function(standards) {
    let clusters = [];
    standards.forEach(_standard => {
      let cluster_id = _standard ? nodes[_standard].ccmathcluster_id: null;
      let cluster = {};
      cluster = map(window.cc.clusters, function(c) {
          if (c.id === cluster_id) return c;
      });
      cluster = without(cluster, undefined);
      cluster.standard = _standard;
      cluster.standardObj = nodes[_standard];
      let _domain = find(window.cc.domains, (d) => d.id === cluster[0].ccmathdomain_id);
      cluster.domain = _domain;
      cluster.domain_id = _domain.id;
      clusters.push(cluster);
    });
    return clusters;
  }

  let getDomainByStandard = function(_standard) {
    let cluster_id = _standard ? nodes[_standard].ccmathcluster_id: null;
    let cluster = {};
    cluster = map(window.cc.clusters, function(c) {
      if (c.id === cluster_id) return c;
    });
    cluster = without(cluster, undefined);
    let _domain = find(window.cc.domains, (d) => d.id === cluster[0].ccmathdomain_id);
    return _domain;
  }

  let compare = function(a,b) {
    if (a.standardObj.ccmathcluster_id === b.standardObj.ccmathcluster_id &&
      (parseInt(a.standardObj.ordinal) < parseInt(b.standardObj.ordinal)))
      return -1;
    if ( a.standardObj.ccmathcluster_id === b.standardObj.ccmathcluster_id && 
      (parseInt(a.standardObj.ordinal) > parseInt(b.standardObj.ordinal))
    )
      return 1;
    return 0;
  }
  let compare2 = function(a,b) {
    if (a.domain.ordinal === b.domain.ordinal &&
      ((b[0].ordinal) > (a[0].ordinal)))
      return -1;
    if ( a.domain.ordinal === b.domain.ordinal && 
      ((a[0].ordinal) < (b[0].ordinal)) 
    )
      return 1;
    return 0;
  }
  if (_getDomain && _getDomain.grade && _getDomain.grade === 'HS'
    /* && ( (this.props.root == this.props.standard) || (this.props.root && !this.props.standard)) */ ) {
    subgraph.forEach((element, index) => {
      let _clusters = listClusterByStandard(element);
      let __clusters_hs = map(_clusters, function(c) {
        if (c.domain.grade === 'HS') return c;
      });
      __clusters_hs = without(__clusters_hs, undefined);
      
      let __clusters_not_hs = map(_clusters, function(c) {
        if (c.domain.grade !== 'HS') return c;
      });
      __clusters_not_hs = without(__clusters_not_hs, undefined);

      let ___clusters = [];
      __clusters_not_hs.forEach(element => {
        ___clusters.push(element);
      });
      __clusters_hs = sortBy(__clusters_hs, function (el) {
        return el[0].ordinal && el.domain.ordinal ;
      });
      __clusters_hs.sort(compare2);
      __clusters_hs.sort(compare);
      __clusters_hs.forEach(element => {
        ___clusters.push(element);
      });

      let _subgraph = [];
      ___clusters.forEach(_cluster => {
        _subgraph.push(_cluster.standard);
      });
      subgraph[index] = _subgraph;
    });
  }
}



// WEBPACK FOOTER //
// ./helpers/utils.js